import { ArrowRight } from 'lucide-react';

import { PrimaryCTA } from '../../components/PrimaryCTA';
import { SecondaryCTA } from '../../components/SecondaryCTA';
import { SectionWrapper } from '../../components/SectionWrapper';
import { MARKETING_APP_ENTRY_HREF } from '../../marketingContent';

import styles from './about.module.css';

export function AboutCta() {
  return (
    <SectionWrapper
      background="white"
      className={styles.ctaSection}
      data-testid="about-section-cta"
    >
      <div className={styles.ctaContent}>
        <h2 className={styles.ctaTitle}>
          See what a course on Kudu actually looks like.
        </h2>
        <p className={styles.ctaSubhead}>
          The fastest way to understand the platform is to spend a few minutes
          inside it. Try a free course in your subject — no credit card, no
          sales call.
        </p>
        <div className={styles.ctaButtons}>
          <PrimaryCTA
            href={MARKETING_APP_ENTRY_HREF}
            icon={<ArrowRight aria-hidden="true" size={16} />}
            label="Start a free course in 2 minutes"
          />
          <SecondaryCTA href="/contact" label="Talk to a co-founder" />
        </div>
        <p className={styles.ctaMicrocopy}>
          Free for instructors · Faculty keep their copyright · No data sold,
          ever
        </p>
      </div>
    </SectionWrapper>
  );
}
